/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Observable, of } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';
import { AbstractLegalEntitySearchService } from '@well/common-libs/legal-entity-management/data-access';

@Injectable()
export class LegalEntityAutocompleteService {

  constructor(private legalEntitySearchService: AbstractLegalEntitySearchService) {
  }

  findAll(country: string, query: any): Observable<LegalEntityModel[]> {
    return this.legalEntitySearchService
      .searchLocalLegalEntity(query)
      .pipe(
        map(res => {
          this.addOriginToLegalEntities(res.data, 'LOCAL');
          return res.data;
        }),
        concatMap((legalEntities: LegalEntityModel[]) => {
          if (legalEntities.length === 0) {
            return this.findAllFromAnaf(query);
            // return this.findAllFromCoface(country, query);
          } else {
            return of(legalEntities);
          }
        })
      );
  }

  findAllFromAnaf(query: any): Observable<LegalEntityModel[]> {
    return this.legalEntitySearchService
      .searchAnafLegalEntity(query)
      .pipe(
        map(res => {
          this.addOriginToLegalEntities(res.data, 'ANAF');
          return res.data;
        })
      );
  }

  findAllFromCoface(country: string, event: any): Observable<LegalEntityModel[]> {
    return this.legalEntitySearchService
      .searchCofaceLegalEntity(country, event.query)
      .pipe(
        map(res => {
          this.addOriginToLegalEntities(res.data, 'COFACE');
          return res.data;
        })
      );
  }

  private addOriginToLegalEntities(legalEntities: LegalEntityModel[], origin: 'LOCAL' | 'ANAF' | 'COFACE'): void {
    legalEntities.forEach(le => le.origin = origin);
  }

  extractNumericPart(query: string): string {
    return query.replace(/\D/g, '');
  }

  containsNumbers(query: string): boolean {
    return /\d/.test(query);
  }
}
